var map = {
	"./cover.jpg": 8232,
	"./image1.jpg": 5361,
	"./image2.jpg": 7590,
	"./image3.jpg": 6115,
	"./image4.jpg": 4464,
	"./image5.jpg": 5389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6511;